import React from 'react';

export default function Pagination({ currentPage, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  const pages = [];
  const start = Math.max(1, currentPage - 2);
  const end   = Math.min(totalPages, currentPage + 2);

  for (let i = start; i <= end; i++) pages.push(i);

  return (
    <div className="flex items-center justify-center gap-1 mt-4">
      <PageBtn
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        label="← Prev"
      />

      {start > 1 && (
        <>
          <PageBtn onClick={() => onPageChange(1)} label="1" active={currentPage === 1} />
          {start > 2 && <span className="px-2 text-slate-400">…</span>}
        </>
      )}

      {pages.map((p) => (
        <PageBtn key={p} onClick={() => onPageChange(p)} label={String(p)} active={p === currentPage} />
      ))}

      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="px-2 text-slate-400">…</span>}
          <PageBtn onClick={() => onPageChange(totalPages)} label={String(totalPages)} active={currentPage === totalPages} />
        </>
      )}

      <PageBtn
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        label="Next →"
      />
    </div>
  );
}

function PageBtn({ onClick, label, active, disabled }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        min-w-[36px] h-9 px-3 text-sm rounded-lg font-medium transition-colors
        ${active
          ? 'bg-blue-600 text-white'
          : disabled
            ? 'text-slate-300 cursor-not-allowed'
            : 'text-slate-600 hover:bg-slate-100'
        }
      `}
    >
      {label}
    </button>
  );
}
